import React from "react";
//components
import { InfoImg, TabeleRowContent } from "./styles";
import { HeaderText } from "../style";
import { currencyOutputNumber } from "utils/CurrencyOutput";
import { Button } from "../../../../../../../components/Button";
//utils
import { generateRandomId } from "utils/GenerateRandomId";
//assets
import { format } from "date-fns";
import iconInfo from "img/icon-info.svg";
import { Tooltip } from 'react-tooltip';


export const PriceHistoryTableRow = ({ applyPriceFunction, item }: any) => {
  const tooltipId = generateRandomId("TooltipPrice");

  return (
    <TabeleRowContent>
      <HeaderText contrast>
        {item?.date && format(new Date(item?.date), "dd/MM/yyyy")}
      </HeaderText>
      <HeaderText contrast>
        {item?.distributionCenter}
      </HeaderText>
      <HeaderText contrast>
        <InfoImg src={iconInfo} alt="info" data-tooltip-id={tooltipId} data-tooltip-content={item?.supplierProductDescription} />
        <Tooltip id={tooltipId} variant="light" />
        <span>{item?.supplierProductCode}</span>
      </HeaderText>
      <HeaderText contrast>
        {item?.rentability}
      </HeaderText>
      <Button
        onClick={() => applyPriceFunction(item?.price)}
        className="priceHistoryModalFontWeight bg-greenDarkViveo color-white"
      >
        <p>
          {currencyOutputNumber(item?.price)}
        </p>
      </Button>
    </TabeleRowContent>
  );
};
